var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallWidget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.425 0.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cube",
    transform: "translate(-0.425 -0.65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1544",
    "data-name": "Rectangle 1544",
    width: 20,
    height: 20,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M15.9,6.119c0-.051-.073-.1-.11-.153l-.066-.073a1.826,1.826,0,0,0-.628-.5L10.423,3.2a1.972,1.972,0,0,0-1.651,0L4.1,5.4a1.9,1.9,0,0,0-.628.5l-.088.037a.731.731,0,0,0-.11.146A1.747,1.747,0,0,0,3,7v5.159a1.819,1.819,0,0,0,1.067,1.651L8.742,16A1.972,1.972,0,0,0,10.4,16l4.676-2.192a1.819,1.819,0,0,0,1.074-1.637V7a1.747,1.747,0,0,0-.248-.877ZM9.363,4.511a.533.533,0,0,1,.424,0l3.894,1.812L9.575,8.23,5.469,6.323ZM4.68,12.505a.343.343,0,0,1-.219-.314V7.463L8.845,9.5v4.91Zm9.782,0-4.157,1.907V9.5l4.383-2.039v4.706a.351.351,0,0,1-.226.336Z",
    transform: "translate(0.425 0.713)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallWidget);
export default __webpack_public_path__ + "static/media/install-widget.8653249ff86910f3bd1baa51dea6bccc.svg";
export { ForwardRef as ReactComponent };